import * as DTOS from "../FeralScan.dtos";

export interface IBaseSummaryDataActions {
    type: string;
}

export interface IGetMetadataRequestAction extends IBaseSummaryDataActions {
    groupId: number;
    userId: number;
}

export interface IGetMetadataSuccessAction extends IBaseSummaryDataActions {
    user: DTOS.SummaryUser;
    userGroup: DTOS.SummaryUserGroup;
}


export interface IGetPlotEventsCountRequestAction extends IBaseSummaryDataActions {
    groupId: number;
    userId: number;
    plotEventStartDateStart: any;
    plotEventStartDateEnd: any;
    classificationIds: number[];
    mustIncludeClassificationId?: number;
}

export interface IGetPlotEventsCountSuccessAction extends IBaseSummaryDataActions {
    data: DTOS.GraphNamedData[];
}

export interface IGetSurveyResultsRequestAction extends IBaseSummaryDataActions {
    userGroupId: number;
    userId: number;
    surveyCode: string;
    plotEventCreatedStartDate: any;
    plotEventCreatedEndDate: any;
}

export interface IGetSurveyResultsSuccessAction extends IBaseSummaryDataActions {
    summaryResults: DTOS.IntegerData[];
    groupedUserResults: DTOS.GroupedData;
    userGroupId: number;
    surveyId: number;
}

export const
    GET_METADATA_REQUEST = "GET_METADATA_REQUEST",
    GET_METADATA_SUCCESS = "GET_METADATA_SUCCESS",

    GET_SURVEY_RESULTS_REQUEST = "GET_SURVEY_RESULTS_REQUEST",
    GET_SURVEY_RESULTS_SUCCESS = "GET_SURVEY_RESULTS_SUCCESS",

    GET_PLOT_EVENTS_COUNT_REQUEST = "GET_PLOT_EVENTS_COUNT_REQUEST",
    GET_PLOT_EVENTS_COUNT_SUCCESS = "GET_PLOT_EVENTS_COUNT_SUCCESS";

export function getSurveyResultsRequest(groupId: number, userId: number, surveyCode: string, plotEventCreatedStartDate: any, plotEventCreatedEndDate: any): IGetSurveyResultsRequestAction {
    return {
        type: GET_SURVEY_RESULTS_REQUEST,
        userGroupId: groupId,
        userId: userId,
        surveyCode: surveyCode,
        plotEventCreatedStartDate: plotEventCreatedStartDate, 
        plotEventCreatedEndDate: plotEventCreatedEndDate
    };
}

export function getSurveyResultsSuccess(response: DTOS.GetSummarySurveyResultsResponse): IGetSurveyResultsSuccessAction {
    return {
        type: GET_SURVEY_RESULTS_SUCCESS,
        summaryResults: response.summaryResults,
        groupedUserResults: response.groupedUserResults,
        userGroupId: response.groupId,
        surveyId: response.surveyId
    };
}

export function getPlotEventsCountRequest(groupId: number, userId: number, plotEventStartDateStart: any, plotEventStartDateEnd: any, classificationIds: number[], mustIncludeClassificationId?: number): IGetPlotEventsCountRequestAction {
    return {
        type: GET_PLOT_EVENTS_COUNT_REQUEST,
        groupId,
        userId,
        plotEventStartDateStart,
        plotEventStartDateEnd,
        classificationIds,
        mustIncludeClassificationId
    }
}

export function getPlotEventsCountSuccess(response: DTOS.GetSummaryPlotEventsCountResponse): IGetPlotEventsCountSuccessAction {
    return {
        type: GET_PLOT_EVENTS_COUNT_SUCCESS,
        data: response.graphData,
    }
}


export function getMetadataRequest(groupId?: number, userId?: number): IGetMetadataRequestAction {
    return {
        type: GET_METADATA_REQUEST,
        groupId: groupId,
        userId: userId
    };
}

export function getMetadataSuccess(response): IGetMetadataSuccessAction {
    return {
        type: GET_METADATA_SUCCESS,
        user: response.user,
        userGroup: response.userGroup
    };
}